import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '@shared/services/translation/translation.service';

@Pipe({
  name: 'itemsForChart'
})
export class ItemsForChartPipe implements PipeTransform {

  constructor(
    private translation: TranslateService,
    private translationService: TranslationService
  ) {}

  // Use i18n currently loaded translation, since translations cannot be localized
  public currentLang = this.translation.currentLang;

  public transform(items: any[], lang?: any): any {
    const options = [];
    if (lang) {
      this.currentLang = lang;
    }
    items.forEach(item => {
      if (item.translations) {
        options.push({
          value: item.count,
          name: this.translationService.getTranslationValue(item.translations, this.currentLang)
        });
      }
    });
    return options;
  }

}
